import { useNavigate, useParams } from "react-router-dom";
import { Message } from "primereact/message";
import { Breadcrumb, PageHeader, TenantGateBanner, useTenantGate } from "../../components/ui";
import { useGetBannersQuery } from "../../store/services/banners";
import { BannerForm } from "./BannerForm";
import { countActiveBannersExcluding } from "./bannerFormRules";
import { BannerQueryFeedback } from "./BannerQueryFeedback";
import "./banners.css";

const TenantBannerEditor = ({ tenantId, bannerId }: { tenantId: string; bannerId?: string }) => {
  const navigate = useNavigate();
  const { currentData, isFetching, isError, error, refetch } = useGetBannersQuery(
    { tenantId },
    { refetchOnMountOrArgChange: true, pollingInterval: 30000, skipPollingIfUnfocused: true }
  );
  const banner = currentData?.find((candidate) => candidate.id === bannerId);
  return (
    <>
      <BannerQueryFeedback isError={isError} isFetching={isFetching} hasData={!!currentData} error={error} onRetry={() => void refetch()} />
      {bannerId && currentData && !banner && !isError && !isFetching && (
        <Message severity="warn" text="El banner no está disponible en el tenant seleccionado." />
      )}
      {(!bannerId || banner) && (
        <BannerForm tenantId={tenantId} banner={banner} disabled={Boolean(bannerId && (isError || !currentData))}
          activeBannerCount={countActiveBannersExcluding(currentData ?? [], bannerId)}
          onClose={() => navigate("/config/home-banners")} />
      )}
    </>
  );
};

export const BannerEditor = () => {
  const { bannerId } = useParams<{ bannerId: string }>();
  const gate = useTenantGate();
  const title = bannerId ? "Editar banner" : "Crear banner";
  return (
    <>
      <Breadcrumb items={[{ label: "Banners del Home", to: "/config/home-banners" }, { label: title }]} />
      <section className="p-card banners-page" aria-label={title}>
        <PageHeader title={title} />
        {gate.allowed && gate.tenantId ? (
          <TenantBannerEditor key={`${gate.tenantId}:${bannerId ?? "new"}`} tenantId={gate.tenantId} bannerId={bannerId} />
        ) : <TenantGateBanner action={bannerId ? "editar el banner" : "crear el banner"} gate={gate} />}
      </section>
    </>
  );
};
